module.exports = __webpack_public_path__ + "img/stats_split.c41d7d9d.png";